export default __webpack_public_path__ + "static/media/1878.fb89846e.png";